import { render, staticRenderFns } from "./BannerListagem.vue?vue&type=template&id=01b074ea&scoped=true"
import script from "./BannerListagem.vue?vue&type=script&lang=js"
export * from "./BannerListagem.vue?vue&type=script&lang=js"
import style0 from "./BannerListagem.vue?vue&type=style&index=0&id=01b074ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b074ea",
  null
  
)

export default component.exports